/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuwriteyourself2Inputs */

const en_menuwriteyourself2 = /** @type {(inputs: Menuwriteyourself2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter it yourself`)
};

const de_menuwriteyourself2 = /** @type {(inputs: Menuwriteyourself2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbst eintragen`)
};

/**
* | output |
* | --- |
* | "Enter it yourself" |
*
* @param {Menuwriteyourself2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuwriteyourself2 = /** @type {((inputs?: Menuwriteyourself2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuwriteyourself2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuwriteyourself2(inputs)
	return de_menuwriteyourself2(inputs)
});
export { menuwriteyourself2 as "menuWriteYourself" }